document.addEventListener('DOMContentLoaded', function () {
  var grid = document.getElementById('shStatsGrid');
  if (!grid) return;

  var numbers = Array.prototype.slice.call(grid.querySelectorAll('[data-count-to]'));
  var animated = false;

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target + suffix;
      }
    }
    requestAnimationFrame(step);
  }

  function triggerAll() {
    if (animated) return;
    animated = true;
    numbers.forEach(animateCount);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          triggerAll();
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });
    observer.observe(grid);
  } else {
    triggerAll();
  }
});
